import { Product, RoleFormModel } from '@user/store/roles/typings'
import React from 'react'
import { AlertDialogSlide, SideDrawerForm } from '@sales-center/components'
import { useHandlers } from './hooks/useHandlers'
import CreateUpdateForm from './CreateUpdateForm'
import {
  adminRoleName,
  guestRoleName,
} from '@user/components/Settings/Users/UpdateUser/constants'

type Props = {
  open: boolean
  onClose: () => void
  products: Product[]
  role?: RoleFormModel
}

export function CreateUpdateSideDrawer(props: Props) {
  const { onClose, products, role } = props

  const {
    submitForm,
    createRole,
    handleWarningModel,
    openWarningModel,
    updateRole,
    disableSave,
  } = useHandlers({ role })

  const isAdmin = role?.name === adminRoleName
  const isGuestUser = role?.name === guestRoleName

  const onSaveAction = isAdmin
    ? updateRole
    : role
      ? handleWarningModel
      : submitForm

  return (
    <>
      <SideDrawerForm
        tidalMode={true}
        onSave={() => onSaveAction()}
        onCancel={onClose}
        disableSave={disableSave || isGuestUser}
        secondaryBtnLabel="Cancel"
        padding="0 20px"
        primaryBtnLabel="Save"
        containerStyle={{
          py: 0,
          px: 2,
        }}
      >
        <CreateUpdateForm
          products={products}
          isAdmin={isAdmin}
          isGuestUser={isGuestUser}
        />
      </SideDrawerForm>
      <AlertDialogSlide
        backdropClick={handleWarningModel}
        open={openWarningModel}
        title="Create new Role?"
        message="You have changed a Role, would you like to update it or create a new one?"
        okClick={createRole}
        okButtonDisabled={disableSave}
        okButtonText="Create New"
        cancelClick={handleWarningModel}
        cancelButtonText="Cancel"
        middleButtonClick={updateRole}
        middleButtonDisabled={disableSave}
        middleButtonTestId="updateBtn"
        middleButtonText="Update Existing"
      />
    </>
  )
}
